import React, { useState } from 'react';

interface TargetRecord {
    id: number;
    outlet: string;
    details: string;
    fromDate: string;
    toDate: string;
    targetAmount: string;
    activeStatus: string;
}

export const ManageTarget: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState('');

    // Mock data based exactly on the mockup image (both rows showing Kanchan Dairy Farm Malad target details)
    const [records] = useState<TargetRecord[]>([
        {
            id: 1,
            outlet: 'Kanchan Dairy Farm Malad',
            details: '6000022',
            fromDate: '2017-11-30',
            toDate: '2017-11-30',
            targetAmount: '100',
            activeStatus: '-'
        },
        {
            id: 1, // keeping ID 1 as in mockup image
            outlet: 'Kanchan Dairy Farm Malad',
            details: '6000022',
            fromDate: '2017-11-30',
            toDate: '2017-11-30',
            targetAmount: '100',
            activeStatus: '-'
        }
    ]);

    const handleDeactivate = (id: number, outlet: string) => {
        if (window.confirm(`Are you sure you want to deactivate target for ${outlet}?`)) {
            alert(`Target for ID ${id} deactivated successfully!`);
        }
    };

    const filteredRecords = records.filter(rec => 
        rec.outlet.toLowerCase().includes(searchTerm.toLowerCase()) ||
        rec.details.includes(searchTerm) ||
        rec.targetAmount.includes(searchTerm)
    );

    return (
        <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
            
            {/* Header and Search */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <span className="text-sm font-bold text-[#1F1F1F] select-none">
                    Manage Target
                </span>
                
                {/* Search Bar */}
                <div className="relative">
                    <input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="bg-white border border-slate-200 rounded-full px-4 py-1 text-xs outline-none focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] w-48 font-medium placeholder-slate-400"
                    />
                </div>
            </div>

            {/* Table Area */}
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse min-w-[900px]">
                    <thead>
                        <tr className="bg-[#FFF9F3] text-[11px] font-bold text-slate-500 select-none">
                            <th className="py-3.5 px-4 rounded-l-xl">ID</th>
                            <th className="py-3.5 px-4">Outlet</th>
                            <th className="py-3.5 px-4">Details</th>
                            <th className="py-3.5 px-4">From Dtae</th> {/* preserved mockup typo */}
                            <th className="py-3.5 px-4">To Date</th>
                            <th className="py-3.5 px-4">Target Amount</th>
                            <th className="py-3.5 px-4">Active</th>
                            <th className="py-3.5 px-4 text-center rounded-r-xl">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {filteredRecords.map((rec, index) => (
                            <tr key={`${rec.id}-${index}`} className="hover:bg-slate-50/50 transition-colors">
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.id}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.outlet}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.details}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.fromDate}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.toDate}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.targetAmount}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    {rec.activeStatus}
                                </td>
                                <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                    <div className="flex items-center justify-center gap-2">
                                        {/* Edit */}
                                        <button className="px-3 py-1 bg-[#5D4037] hover:bg-[#4E342E] text-white rounded-full text-[10px] font-semibold transition-all cursor-pointer">
                                            Edit
                                        </button>
                                        {/* Deactivate */}
                                        <button 
                                            onClick={() => handleDeactivate(rec.id, rec.outlet)}
                                            className="px-3 py-1 go_erp-bg text-white rounded-full text-[10px] font-semibold transition-all cursor-pointer"
                                        >
                                            Deactivate
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        {filteredRecords.length === 0 && (
                            <tr>
                                <td colSpan={8} className="py-8 text-center text-xs font-semibold text-slate-400">
                                    No target records found matching your search.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default ManageTarget;
